"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var asg_1 = require("@alinta-digital/asg");
var components_1 = require("../../components");
var Styles_1 = require("./Styles");
var formik_1 = require("formik");
var react_scroll_1 = require("react-scroll");
var paymentForm_1 = require("@alinta-digital/myaccount-frontend-shared/types/paymentForm");
var myaccount_frontend_shared_1 = require("@alinta-digital/myaccount-frontend-shared");
var PaymentSummary = function (props) {
    var _a, _b;
    var onCancel = props.onCancel, onSubmit = props.onSubmit, onEdit = props.onEdit, accountDetails = props.accountDetails, reviewPayment = props.reviewPayment, isUnAuthenticated = props.isUnAuthenticated, savedPaymentId = props.savedPaymentId;
    var paymentToken = reviewPayment.paymentToken, cardType = reviewPayment.cardType, cardNumber = reviewPayment.cardNumber, cardExpiryMonth = reviewPayment.cardExpiryMonth, cardExpiryYear = reviewPayment.cardExpiryYear;
    var _c = (0, react_1.useContext)(asg_1.StepsContext), goToStep = _c.goToStep, completeStep = _c.completeStep;
    (0, myaccount_frontend_shared_1.useAnalyticsLoadV2)(props.ga, 'load.0.reviewpayment');
    var currentStepKey = 'step2';
    var nextStepKey = 'step3';
    var previousStepKey = 'step1';
    var cardExpiry = cardExpiryMonth + " / " + (cardExpiryYear === null || cardExpiryYear === void 0 ? void 0 : cardExpiryYear.slice(2, 4));
    var _d = (0, formik_1.useFormikContext)(), values = _d.values, setFieldValue = _d.setFieldValue, setFieldTouched = _d.setFieldTouched;
    var _e = (0, react_1.useState)(false), loading = _e[0], setLoading = _e[1];
    var accountNumber = !isUnAuthenticated && accountDetails ? accountDetails.accountNumber : values.paymentDetails.accountNumber;
    var paymentRegion = accountDetails ? accountDetails.paymentRegion : '';
    var emailAddress = !isUnAuthenticated && accountDetails ? accountDetails.emailAddress : values.paymentDetails.emailAddress;
    var isPaypalSummary = ((_a = values.paymentDetails) === null || _a === void 0 ? void 0 : _a.selectedOption) && ((_b = values.paymentDetails) === null || _b === void 0 ? void 0 : _b.selectedOption) === 'paypal' ? true : false;
    var isMyAccountPayPal = isPaypalSummary && !isUnAuthenticated;
    var bamboraPaymentDetails = {
        accountNumber: "" + accountNumber,
        paymentRegion: paymentRegion,
        emailAddress: emailAddress,
        paymentToken: paymentToken,
        savePaymentToken: reviewPayment.savePaymentToken,
        amount: parseFloat(values.paymentDetails.paymentAmount),
        hasSavedPaymentMethod: values.paymentDetails.hasSavePaymentMethod,
        savedPaymentId: savedPaymentId,
        ccDetails: {
            expiry: reviewPayment.cardExpiryMonth + "/" + reviewPayment.cardExpiryYear.slice(2),
            name: reviewPayment.name || '',
            number: reviewPayment.cardNumber,
            token: paymentToken,
            type: reviewPayment.creditCardType || paymentForm_1.CreditCardType.MASTERCARD,
            tokenType: paymentForm_1.TokenType.STT
        },
        isPayPalSummary: isPaypalSummary
    };
    var proceedToNextStepCallBack = function () {
        var _a, _b;
        completeStep(currentStepKey);
        if (!isPaypalSummary) {
            if (((_a = props.ga) === null || _a === void 0 ? void 0 : _a.eventName) === 'process.payment') {
                (_b = props.ga) === null || _b === void 0 ? void 0 : _b.push('click.1.reviewpayment.confirm');
            }
            goToStep(nextStepKey);
        }
    };
    var contentProperties = {
        header: {
            hide: false,
            title: 'Review payment',
            onclick: function () {
                var _a, _b;
                if (((_a = props.ga) === null || _a === void 0 ? void 0 : _a.eventName) === 'process.web.payment') {
                    (_b = props.ga) === null || _b === void 0 ? void 0 : _b.push('click.1.reviewpayment.change');
                }
                if (onEdit) {
                    onEdit();
                }
            }
        },
        footer: {
            hide: false,
            leftButton: {
                label: 'Cancel',
                disabled: false,
                onClick: function () {
                    var _a, _b, _c;
                    if (((_a = props.ga) === null || _a === void 0 ? void 0 : _a.eventName) === 'process.payment') {
                        props.ga.push('click.1.reviewpayment.cancel');
                    }
                    if (((_b = props.ga) === null || _b === void 0 ? void 0 : _b.eventName) === 'process.web.payment') {
                        (_c = props.ga) === null || _c === void 0 ? void 0 : _c.push('click.3.reviewpayment.cancel');
                    }
                    onCancel();
                }
            },
            rightButton: {
                label: 'Confirm',
                disabled: loading,
                loading: loading,
                onClick: function () {
                    var _a, _b, _c;
                    if (isMyAccountPayPal) {
                        (_a = props.ga) === null || _a === void 0 ? void 0 : _a.push('click.1.paypalbutton');
                    }
                    if (((_b = props.ga) === null || _b === void 0 ? void 0 : _b.eventName) === 'process.web.payment') {
                        (_c = props.ga) === null || _c === void 0 ? void 0 : _c.push('click.2.reviewpayment.confirm');
                    }
                    setLoading(true);
                    if (onSubmit)
                        onSubmit(bamboraPaymentDetails, proceedToNextStepCallBack);
                },
                isPayWithPaypalButton: isPaypalSummary
            }
        }
    };
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (isMyAccountPayPal) {
            if (((_a = props.ga) === null || _a === void 0 ? void 0 : _a.eventName) === 'process.payment') {
                (_b = props.ga) === null || _b === void 0 ? void 0 : _b.push('load.0.paypalbutton');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(function () {
        react_scroll_1.scroller.scrollTo(currentStepKey + "-top-element", {
            duration: 0,
            smooth: true,
            offset: -50
        });
    }, [currentStepKey]);
    return (react_1.default.createElement(components_1.Content, (0, tslib_1.__assign)({}, contentProperties),
        react_1.default.createElement(react_scroll_1.Element, { name: currentStepKey + "-top-element" },
            react_1.default.createElement(asg_1.Box, { direction: "row", margin: { bottom: 'medium' } },
                react_1.default.createElement(asg_1.Box, { width: "70%" },
                    react_1.default.createElement(asg_1.Heading, { level: "3", weight: 700, color: asg_1.colors['colour-black'] }, "Payment summary")),
                react_1.default.createElement(asg_1.Box, { width: "30%" },
                    react_1.default.createElement(asg_1.Box, { height: "100%" },
                        react_1.default.createElement(Styles_1.EditLink, { alignSelf: "end", width: "fit-content", "data-testid": "editLink", onClick: function (event) {
                                var _a, _b, _c, _d;
                                event.preventDefault();
                                if (((_a = props.ga) === null || _a === void 0 ? void 0 : _a.eventName) === 'process.web.payment') {
                                    (_b = props.ga) === null || _b === void 0 ? void 0 : _b.push('click.1.reviewpayment.change');
                                }
                                if (((_c = props.ga) === null || _c === void 0 ? void 0 : _c.eventName) === 'process.payment') {
                                    (_d = props.ga) === null || _d === void 0 ? void 0 : _d.push('click.1.reviewpayment.edit');
                                }
                                setFieldValue('paymentDetails.cardName', '');
                                setFieldTouched('paymentDetails.cardName', false);
                                goToStep(previousStepKey);
                            }, color: asg_1.colors['colour-secondary'] }, "Edit")))),
            react_1.default.createElement(asg_1.FlexGrid, null,
                accountDetails && (react_1.default.createElement(asg_1.FlexGridItem, { xs: 12, sm: 6, margin: { bottom: 'xsmall' } },
                    react_1.default.createElement(asg_1.FlexGrid, { direction: "column" },
                        react_1.default.createElement(asg_1.FlexGridItem, { margin: { bottom: '2px' } },
                            react_1.default.createElement(asg_1.Text, { color: asg_1.colors['colour-black'], weight: 600, size: "medium" }, "Account details")),
                        react_1.default.createElement(asg_1.FlexGridItem, null,
                            react_1.default.createElement(asg_1.Text, { color: asg_1.colors['colour-black'], weight: 400, size: "medium", "data-testid": "accountDetails" },
                                accountDetails.fuelType,
                                " - ",
                                accountDetails.address))))),
                react_1.default.createElement(asg_1.FlexGridItem, { xs: 12, sm: 6, margin: { bottom: 'xsmall' } },
                    react_1.default.createElement(asg_1.FlexGrid, { direction: "column" },
                        react_1.default.createElement(asg_1.FlexGridItem, null,
                            react_1.default.createElement(asg_1.Text, { color: asg_1.colors['colour-black'], weight: 600, size: "medium" }, "Account number")),
                        react_1.default.createElement(asg_1.FlexGridItem, null,
                            react_1.default.createElement(asg_1.Text, { color: asg_1.colors['colour-black'], size: "medium", weight: 400, "data-testid": "accountNumber" }, accountNumber)))),
                react_1.default.createElement(asg_1.FlexGridItem, { xs: 12, sm: isUnAuthenticated && 6, margin: { bottom: 'xsmall' } },
                    react_1.default.createElement(asg_1.FlexGrid, { direction: "column" },
                        react_1.default.createElement(asg_1.FlexGridItem, null,
                            react_1.default.createElement(asg_1.Text, { color: asg_1.colors['colour-black'], weight: 600, size: "medium" }, "Payment amount")),
                        react_1.default.createElement(asg_1.FlexGridItem, null,
                            react_1.default.createElement(asg_1.Text, { color: asg_1.colors['colour-black'], size: "medium", weight: 400, "data-testid": "paymentAmount" },
                                "$",
                                values.paymentDetails.paymentAmount)))),
                !isPaypalSummary && isUnAuthenticated && emailAddress && (react_1.default.createElement(asg_1.FlexGridItem, { xs: 12, margin: { bottom: 'xsmall' } },
                    react_1.default.createElement(asg_1.FlexGrid, { direction: "column" },
                        react_1.default.createElement(asg_1.FlexGridItem, null,
                            react_1.default.createElement(asg_1.Text, { color: asg_1.colors['colour-black'], weight: 600, size: "medium" }, "Your email (optional)")),
                        react_1.default.createElement(asg_1.FlexGridItem, null,
                            react_1.default.createElement(asg_1.Text, { color: asg_1.colors['colour-black'], size: "medium", weight: 400, "data-testid": "emailAddress" }, emailAddress))))),
                !isPaypalSummary && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(asg_1.FlexGridItem, { xs: 12, sm: 6 },
                        react_1.default.createElement(asg_1.FlexGrid, { direction: "column" },
                            react_1.default.createElement(asg_1.FlexGridItem, null,
                                react_1.default.createElement(asg_1.Text, { color: asg_1.colors['colour-black'], weight: 600, size: "medium" }, "Card number")),
                            react_1.default.createElement(asg_1.FlexGridItem, null,
                                react_1.default.createElement(Styles_1.MaskedCardNumber, { className: cardType, "data-testid": "maskedCardNumber" },
                                    react_1.default.createElement(asg_1.Text, { color: asg_1.colors['colour-black'], weight: 400, size: "medium", "data-testid": "cardNumber" }, cardNumber))))),
                    react_1.default.createElement(asg_1.FlexGridItem, { xs: 12, sm: 6 },
                        react_1.default.createElement(asg_1.FlexGrid, { direction: "column" },
                            react_1.default.createElement(asg_1.FlexGridItem, null,
                                react_1.default.createElement(asg_1.Text, { color: asg_1.colors['colour-black'], weight: 600, size: "medium" }, "Card expiry date")),
                            react_1.default.createElement(asg_1.FlexGridItem, null,
                                react_1.default.createElement(asg_1.Text, { color: asg_1.colors['colour-black'], size: "medium", weight: 400, "data-testid": "cardExpiry" }, cardExpiry))))))))));
};
exports.default = PaymentSummary;
//# sourceMappingURL=PaymentSummary.js.map